import { Box, Typography } from '@mui/material';

export type DataGridColumnWithSubtitleProps = {
  title: string;
  subtitle?: string;
};

export function DataGridColumnWithSubtitle({ title, subtitle }: DataGridColumnWithSubtitleProps) {
  if (!subtitle) {
    return <>{title}</>;
  }

  return (
    <Box
      sx={{
        height: 'inherit',
        width: '100%',
        lineHeight: 'calc(var(--height) / 2.675)',
        textOverflow: 'ellipsis',
        whiteSpace: 'inherit',
        overflow: 'hidden',
        margin: 'inherit',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      {title}
      <Typography
        color="textDisabled"
        variant="body2"
        sx={{
          lineHeight: 'inherit',
          textOverflow: 'ellipsis',
          whiteSpace: 'inherit',
          overflow: 'hidden',
          margin: 'inherit',
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
}
